import { gsap, Power2 } from 'gsap/gsap-core'
import Lottie from 'lottie-web'
import { loadHeroBlock } from '../sections/first'


let pageLoaded = false
let loaderInterval = null
let preloaderLottie = $('#preloader-animation')

if(preloaderLottie.length) {

  let path = preloaderLottie.attr('data-animation-path')
  let introId = 'preloader-animation'

  let svgContainer = document.getElementById(introId)

  let animation = Lottie.loadAnimation({
    container: svgContainer,
    animType: 'svg',
    loop: false,
    autoplay: true,
    path: path
  });

  animation.addEventListener('complete', animationDone);

  function animationDone() {
    $('body').addClass('page-loaded')
  }


  function animationFinished() {
    loaderInterval = setInterval(function (){
      if(pageLoaded && $('body').hasClass('page-loaded')) {
        clearInterval(loaderInterval)
        removePreloader()
      }
    }, 100)
  }

  function removePreloader() {
    let removePreloader = gsap.timeline({
      onComplete: pageActive
    })
    removePreloader.fromTo('#preloader', {y: 0}, {y: '-100%', duration: 1, ease: Power2.easeIn})
  }

  function pageActive(){
    $('body').removeClass('page-loading')
    $('#preloader').remove()

    loadHeroBlock()
  }

  setTimeout(function (){
    animationFinished()
  }, 100)

}

$(window).on('load', function (e){
  pageLoaded = true
})
